import Objective from "./Objective";

export default Objective;